/** @format */

export default {
    OPTIONS: ['us', 'ca', 'gb', 'ie', 'mx', 'au'],
};
